'use client';

import { IconSearch } from '../icon';
import { useTranslations } from '@fshr/context/i18n-context';

const SearchButton = ({
	onClick,
	theme,
	width = 26.6667,
	height = 28,
}: {
	onClick: () => void;
	theme?: string;
	width?: number;
	height?: number;
}) => {
	const t = useTranslations();
	return (
		<button className="search-modal-button" aria-label={t('open search modal')} onClick={onClick}>
			<IconSearch width={width} height={height} fill={theme === 'dark' ? '#E6E6E6' : '#1F1F1F'} />
		</button>
	);
};

export default SearchButton;
